import { FilterType, Filter, FilterKey, ShareCodeStatus } from 'types';
import { IGetFilterGroupsProps } from '../../types';

const ShareCodeOptions = [
  {
    label: 'None',
    value: ShareCodeStatus.NONE,
  },
  {
    label: 'Verified',
    value: ShareCodeStatus.VERIFIED,
  },
  {
    label: 'Not Verified',
    value: ShareCodeStatus.NOT_VERIFIED,
  },
  {
    label: 'Expiring Soon',
    value: ShareCodeStatus.EXPIRING_SOON,
  },
  {
    label: 'Expired',
    value: ShareCodeStatus.EXPIRED,
  },
];

const key = FilterKey.SHARE_CODE;
export const getShareCodeFilter = ({ activeFilters }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const options = ShareCodeOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });

  return {
    name: 'Share Code',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: false,
    options: {
      SELECT_MANY: options,
    },
  };
};
